/* eslint-disable function-paren-newline */
import { useEffect, useState } from 'react';

import { useAppDispatch } from '@store/index';
import { loginInVoov } from '@store/authentication/authentication.trunk';
import wemeetClient, { initWeMeetClient } from '@utils/wemeetClient';
import { CONSTANTS, SdkAPPId, UserDistrict } from '@tencent/wemeet-websdk-next';
import { setMeetingInfoInput } from '@store/meeting/meeting.slice';
import { reportUserLoginFail, reportUserLoginSuceess, setAegisUin } from 'src/report/aegis';
import { getOpenId } from '@utils/wemmet';
import { isBrowserSupport } from '@utils/browserLimit';
import ChromeImg1x from '@asset/image/meeting/chrome.png';
import ChromeImg2x from '@asset/image/meeting/chrome@2x.png';
import { execCommandCopy } from '@utils/browser';
import { useTranslation } from 'react-i18next';
import { openDialog } from '@component/dialog';
import { openToast } from '@component/toast';

const Framework: React.FunctionComponent = ({ children }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const [renderChild, setRenderChild] = useState(false);

  useEffect(() => {
    init();

    /**
     * 在页面初始化的时候就进行登录
     * 1. VooV 登录
     * 2. 初始化 sdk （这一步改成不依赖 voov 登录，拿出这个流程）
     * 3. 建立 XMPP 链接
     *
     * 在进会表格页面，如果登录失败，不需要跳转到 voov 官网登录
     * 进会表格页面，点击进会，如果没有登录则完成登录，
     *
     * 在进会
     */
    async function init() {
      let signalServerUrl = process.env.REACT_APP_XMPP_SIGNAL_SERVER_URL;
      let sdkAppId = process.env.REACT_APP_SDK_APP_ID as SdkAPPId;
      let district = UserDistrict.oversea;

      if (process.env.REACT_APP_DEBUG_TOOL && window.localStorage.getItem('customXmppUrl')) {
        signalServerUrl = window.localStorage.getItem('customXmppUrl') || process.env.REACT_APP_XMPP_SIGNAL_SERVER_URL;
      }
      if (process.env.REACT_APP_DEBUG_TOOL && window.localStorage.getItem('customSdkAppId')) {
        // @ts-ignore
        sdkAppId = Number(window.localStorage.getItem('customSdkAppId'));
      }

      if (process.env.REACT_APP_DEBUG_TOOL && window.localStorage.getItem('customDistrict')) {
        // @ts-ignore
        district = window.localStorage.getItem('customDistrict');
      }
      initWeMeetClient({
        sdkAppId,
        // TODO: 应该在 xmpp login 的时候再传
        signalServerUrl,
        language: CONSTANTS.LanguageType.EN_US,
        district,
      });

      const resultAction = await dispatch(loginInVoov());

      // 账号登录成功
      if (loginInVoov.fulfilled.match(resultAction)) {
        const loginResult = resultAction.payload;
        if (loginResult) {
          if (loginResult?.app_id !== '20000000') {
            dispatch(
              setMeetingInfoInput({
                nickname: loginResult.nick_name,
              }),
            );
          }

          setAegisUin(getOpenId('5', loginResult?.userid ?? '', loginResult?.app_id ?? ''));
          reportUserLoginSuceess();
        } else {
          reportUserLoginFail();
        }
      }

      const isSupportWebRTC = await wemeetClient.mediaCtrl.isSupportWebRTC();
      if (!isSupportWebRTC.support && isBrowserSupport()) {
        openDialog({
          dialogId: 'changeBrowser',
          title: t('请更换浏览器'),
          content: (
            <div className="chrome-dialog">
              <p>{t('暂不支持本浏览器，请复制链接后用以下浏览器打开')}</p>
              <img alt="chrome" className="img" srcSet={`${ChromeImg1x}  1x,${ChromeImg2x} 2x`} />
            </div>
          ),
          okText: t('复制链接'),
          onOk: () => {
            // 复制
            execCommandCopy(window.location.href);
            openToast(t('复制成功'));
          },
        });
      } else {
        setRenderChild(true);
      }
    }
  }, []);
  return <>{renderChild ? children : null}</>;
};

export default Framework;
